module.exports = __webpack_public_path__ + "static/media/Mannu.4d72aace.png";